import { useMemo } from "react";
import useSWR from "swr";

import { fetcher, endpoints } from "src/utils/axios";
import {
  ProductContentAudienceFilter,
  ProductContentContextFilter,
  ProductContentLocale,
  ProductContentResponse,
} from "src/types/product-content";

export function useGetProductContent(
  locale: ProductContentLocale,
  audience: ProductContentAudienceFilter,
  context: ProductContentContextFilter,
  enabled = true,
) {
  const params = new URLSearchParams({ locale, audience, context });
  const URL = enabled
    ? `${endpoints.system.content}?${params.toString()}`
    : null;
  const { data, isLoading, error, isValidating, mutate } =
    useSWR<ProductContentResponse>(URL, fetcher);

  return useMemo(
    () => ({
      productContent: data?.items ?? [],
      newForDays: data?.new_for_days ?? 7,
      productContentLoading: isLoading,
      productContentError: error,
      productContentValidating: isValidating,
      refetchProductContent: mutate,
    }),
    [data, error, isLoading, isValidating, mutate],
  );
}
